module.exports = __webpack_public_path__ + "static/media/zonsondergang_met_camper.0490e9ee.jpg";